import { render, staticRenderFns } from "./IncentiveCalculation.vue?vue&type=template&id=470ff1f4&"
import script from "./IncentiveCalculation.vue?vue&type=script&lang=js&"
export * from "./IncentiveCalculation.vue?vue&type=script&lang=js&"
import style0 from "./IncentiveCalculation.vue?vue&type=style&index=0&id=470ff1f4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports